import {action, observable, runInAction} from 'mobx';
import {decorate, inject, injectable} from '@yosmanyga/di';
import {CredentialManager, DeviceManager, Dispatcher} from '@yosmanyga/base';

class AuthenticationFrontendFrontController {
    @observable accessor loaded: boolean;
    @observable accessor credential: boolean;

    constructor(
        private dispatcher: Dispatcher,
        private deviceManager: DeviceManager,
        private credentialManager: CredentialManager,
    ) {
        this.loaded = false;
        this.credential = false;

        this.dispatcher.register('credential_saved', this.listenToCredentialSaved)
        this.dispatcher.register('credential_deleted', this.listenToCredentialDeleted)
    }

    @action load = async () => {
        await this.deviceManager.load();

        await this.credentialManager.load();

        runInAction(() => {
            this.credential = this.credentialManager.has();
            this.loaded = true;
        });
    };

    @action delete = async () => {
        await this.credentialManager.delete();

        runInAction(() => {
            this.credential = false;
        });
    };

    listenToCredentialSaved = async (
        credential: string
    ) => {
        runInAction(() => {
            this.credential = this.credentialManager.has();
        });
    }

    listenToCredentialDeleted = () => {
        runInAction(() => {
            this.credential = false;
        });
    }
}

decorate(injectable(), AuthenticationFrontendFrontController);
decorate(inject(Dispatcher), AuthenticationFrontendFrontController, 0);
decorate(inject(DeviceManager), AuthenticationFrontendFrontController, 1);
decorate(inject(CredentialManager), AuthenticationFrontendFrontController, 2);

export {AuthenticationFrontendFrontController};
